import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HomeStateProvider, useHome } from "./state";
import { Login } from "./Login";
import { Toasts } from "./components/Toasts";
import { HomePage } from "./pages/HomePage";
import { ClimatePage } from "./pages/ClimatePage";
import { PoolPage } from "./pages/PoolPage";
import { TeslaPage } from "./pages/TeslaPage";
import { MusicPage } from "./pages/MusicPage";

export function App() {
  return (
    <HomeStateProvider>
      <Shell />
    </HomeStateProvider>
  );
}

function Shell() {
  const { token, sessionNotice, submitLogin } = useHome();

  if (!token) {
    return <Login message={sessionNotice} onLogin={submitLogin} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/climate/:zoneId" element={<ClimatePage />} />
        <Route path="/pool" element={<PoolPage />} />
        <Route path="/tesla" element={<TeslaPage />} />
        <Route path="/music" element={<MusicPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toasts />
    </BrowserRouter>
  );
}
